/**
 * Normalizes an amount string to ensure it has a leading zero before the decimal point.
 * This prevents backend rejection with "Invalid number format: missing leading zero".
 *
 * Examples:
 *   ".01"  → "0.01"
 *   "-.5"  → "-0.5"
 *   "+.5"  → "+0.5"
 *   "1.5"  → "1.5"  (unchanged)
 *   ""     → ""     (unchanged)
 */
export function normalizeAmountString(
  value: string | undefined,
): string | undefined {
  if (!value) {
    return value;
  }

  const trimmed = value.trim();
  if (trimmed.startsWith('.')) {
    return `0${trimmed}`;
  }
  if (trimmed.startsWith('-.')) {
    return `-0${trimmed.slice(1)}`;
  }
  if (trimmed.startsWith('+.')) {
    return `+0${trimmed.slice(1)}`;
  }

  return trimmed;
}
